import styled from 'styled-components/macro'
import Typography from '@material-ui/core/Typography'

const Text = styled(Typography)``

export default Text
